import { combineReducers } from '@reduxjs/toolkit';

import { conferencesHistoryFetchingReducer } from './features/fetching/slice';
import { conferencesHistoryFilterReducer } from './features/filter/slice';
import { conferencesHistoryListReducer } from './features/history-items/slice';
import { conferencesHistorySidebarReducer } from './features/sidebar/slice';

export const conferencesHistoryReducer = combineReducers({
    filter: conferencesHistoryFilterReducer,
    list: conferencesHistoryListReducer,
    fetching: conferencesHistoryFetchingReducer,
    sidebar: conferencesHistorySidebarReducer,
});
